import React from 'react'
import Header from '../component/Header/Header'
import FooterNew from '../component/FooterNew/FooterNew'
import HomeHero from '../component/HomeHero/HomeHero'
import PlainTextContent from '../component/PlainTextContent/PlainTextContent'
import ContactPageCard from '../component/ContactPageCard/ContactPageCard'
import HeroBanner from '../component/Common Banner Component/HeroBanner'

function Contact() {
    return (
        <>
          {/* <HomeHero/> */}

          <HeroBanner 
            subHeading=""
            Heading=""
            nextLineSpanHeading=""
            paraWhite={true}
            postSubHeadingRed={""}
            Paragraph=""
            btn={false}
            socialLinks={true}
            serviceForm={true}
            btnText=""
            bgImg="/images/creatives/contact-hero-bg.jpg"
            btnRef="/"
            bannerMarginBottom={false}
            sideLinks={false}
            
          />

          {/* <ContactPageCard/>
   
       
          <PlainTextContent
            heading=' Ready to Lead with Your Story?'
            content={"Let's build a brand that's bold, real and uniquely yours."}
            btnText='Book a Discovery Call'
            btnRef='/'
            bgColor=""
            fontThemeDark={true}
            btnClass='btn-brown'
          /> */}
   
          <FooterNew/>
        </>
      )
}

export default Contact